/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { Service } from 'services';

class RunService extends Service {
  /**
   * Deploys and executes the given process
   *
   * @param {String} diagramId
   * @param {Object} clusterInfo The info of the destination cluster
   * @param {Object} payload JSON object of the payload for the new instance
   * @param {Object} formResolutions A list of the form resolutions for the new deployment
   * @return {Promise}
   */
  runDiagram(diagramId, clusterInfo, payload, formResolutions) {
    return this.post(`/internal-api/files/${diagramId}/execute`, {
      ...clusterInfo,
      formResolutions,
      variables: payload
    });
  }

  /**
   * Deploys and executes the given process application
   *
   * @param {String} processApplicationId
   * @param {Object} clusterInfo The info of the destination cluster
   * @param {Object} payload JSON object of the payload for the new instance
   * @param {Object} formResolutions A list of the form resolutions for the new deployment
   * @return {Promise}
   */
  runProcessApplication(processApplicationId, clusterInfo, payload, formResolutions) {
    return this.post(`/internal-api/process-applications/${processApplicationId}/execute`, {
      ...clusterInfo,
      variables: payload,
      formResolutions
    });
  }
}

export default new RunService();
